import { refreshBankBucket } from './matching.ts'
import type {
  BankPreviewRow,
  ExistingBankPayment,
  ExistingImportTransaction,
} from './types.ts'

export function applyBankDuplicateWarnings(
  rows: readonly BankPreviewRow[],
  payments: readonly ExistingBankPayment[],
  imports: readonly ExistingImportTransaction[],
): BankPreviewRow[] {
  const seenFingerprints = new Set<string>()

  return rows.map((row) => {
    const reasons: string[] = []
    if (!row.removed && row.amountCents > 0) {
      if (
        row.matchedUserId &&
        payments.some(
          (payment) =>
            payment.userId === row.matchedUserId &&
            payment.amountCents === row.amountCents &&
            payment.createdAt === row.transactionDate,
        )
      ) {
        reasons.push('A bank payment already exists for this member, date, and amount')
      }
      if (imports.some((item) => item.sourceFingerprint === row.sourceFingerprint)) {
        reasons.push('This source row was imported previously')
      }
      if (seenFingerprints.has(row.sourceFingerprint)) {
        reasons.push('The same source row appears earlier in this CSV')
      }
      seenFingerprints.add(row.sourceFingerprint)
    }
    return refreshBankBucket({ ...row, duplicateReasons: reasons })
  })
}
